import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Anchor from "./Anchor";
import { SET_NEW_FILTERS, SET_FILTERED_DATA } from "constants/actions";
import styled, { keyframes } from "styled-components";

const Container = styled.div``;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const T1 = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  font-family: "Raleway";
  color: #2a3039;
  line-height: 1.5;
  margin-top: 20px;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  letter-spacing: -0.35px;
`;

const Description = styled.div`
  font-size: 16px;
  color: #2a3039;
  margin-bottom: 20px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 0.5s;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const LongFormAnchorFilters = ({
  setAnchorLabel,
  setAnchorSelected,
  anchorSelected
}) => {
  const dispatch = useDispatch();

  const raw_data = useSelector((state) => state.audit.raw_data, shallowEqual);

  // Reset filters on mount
  useEffect(() => {
    dispatch({ type: SET_NEW_FILTERS, payload: [] });
    dispatch({ type: SET_FILTERED_DATA, payload: raw_data });
  }, [raw_data, dispatch]);

  return (
    <Container style={{ padding: "20px" }}>
      <Section>
        <T1>Select the report target</T1>
        <Description>
          Please select a target for your report. This will determine how the
          results are segregated and displayed.
        </Description>
        <Anchor selectedAnchor={anchorSelected} onSelect={setAnchorSelected}  />
      </Section>
    </Container>
  );
};

export default LongFormAnchorFilters;
